<div class="module-card-container mar-top-3">
  <ng-container *ngFor="let card of cards; let i = index">
    <a
      class="module-card class-link relative cursor-pointer"
      (click)="view(card)"
      (keydown.enter)="view(card)"
      (keydown.space)="view(card)"
      role="button"
      tabindex="0"
      [attr.aria-label]="getCardAriaLabel(card) || null">

      <div
        *ngIf="card.status === CourseStatus.Completed || card.status === CourseStatus.Reviewed || card.status === CourseStatus.Incomplete"
        class="status-banner text-center text-[0.875rem] font-bold py-2 rounded-t-lg"
        [ngClass]="{
          'completed': card.status === CourseStatus.Completed,
          'reviewed': card.status === CourseStatus.Reviewed,
          'incomplete': card.status === CourseStatus.Incomplete
        }">
        <span class="sr-only">Course status:</span> {{ card.status | uppercase }}
      </div>

      <div *ngIf="card.course.img" class="card-imagebg relative">
        <img [src]="card.course.img"
          [alt]="card.course.imageAlt ? card.course.imageAlt : 'Cover image for ' + card.course.name"
          aria-hidden="true" />
      </div>

      <div class="card-title">{{ card.course.name }}</div>
      <p class="card-summary">{{ card.course.description }}</p>

      <span *ngIf="card.course.imageAlt" class="sr-only">{{ card.course.imageAlt }}</span>
    </a>
  </ng-container>
</div>
